module.exports = __webpack_public_path__ + "static/img/background-boticario.fd8d6a5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-boticario.jpeg
// module id = CMD9
// module chunks = 1